/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const SvgArrowLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' role='img' {...props}>
    <path
      d='M10.3647 15.4243C9.85423 15.9292 9.03113 15.9246 8.52626 15.4141L4.0757 10.9141C3.57477 10.4077 3.57477 9.59235 4.0757 9.08585L8.52626 4.58585C9.03113 4.07538 9.85423 4.07083 10.3647 4.5757C10.8752 5.08057 10.8797 5.90367 10.3749 6.41415L8.11413 8.7L15 8.7C15.718 8.7 16.3 9.28203 16.3 10C16.3 10.718 15.718 11.3 15 11.3L8.11413 11.3L10.3749 13.5859C10.8797 14.0963 10.8752 14.9194 10.3647 15.4243Z'
      fill='currentColor'
    />
  </svg>
)
export default SvgArrowLeft
